export default __webpack_public_path__ + "static/media/124.9c3a4bef.jpg";